import { createContext, useContext, useState } from 'react'
import type { ReactNode } from 'react'

interface Country {
  name: string
  count: string
}

interface MapContextType {
  country: Country
  setCountry: (country: Country) => void
}

const MapContext = createContext<MapContextType | null>(null)

export function MapProvider({ children }: { children: ReactNode }) {
  const [country, setCountry] = useState<Country>({ name: '', count: '' })

  return (
    <MapContext.Provider value={{
      country,
      setCountry
    }}>
      {children}
    </MapContext.Provider>
  )
}

const useMap = () => {
  const context = useContext(MapContext)
  if (!context) {
    throw new Error('useMap must be used within MapProvider')
  }
  return context
}